import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const BrandLogoColor = createSvgIcon(
  <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="25.1321"
      cy="7.09331"
      rx="3.8091"
      ry="3.74413"
      fill="#0094FF"
    />
    <ellipse
      cx="16.0488"
      cy="7.09331"
      rx="3.8091"
      ry="3.74413"
      fill="#FEDA00"
    />
    <ellipse
      cx="16.0488"
      cy="16.1176"
      rx="3.8091"
      ry="3.74413"
      fill="#0094FF"
    />
    <ellipse
      cx="6.86793"
      cy="7.09333"
      rx="3.8091"
      ry="3.74413"
      fill="#FE3B1F"
    />
    <ellipse
      cx="6.86791"
      cy="16.1176"
      rx="3.8091"
      ry="3.74413"
      fill="#0094FF"
    />
    <ellipse
      cx="6.86791"
      cy="25.1419"
      rx="3.8091"
      ry="3.74413"
      fill="#0094FF"
    />
  </svg>,
  'BrandLogoColor'
);
